import { useState, useCallback } from 'react';
import { filtersReducer } from '../../_commons/filtersReducer';
// import { useLocations, AirportType } from '../../_commons/locations';
import { useOriginDestination } from '../../_commons/locations';
import { useSubscription } from './subscription';
import { useEffectReducer } from 'use-effect-reducer';
import { useTrackingChangeDatalayer } from '../../../../_integrations/everymundo/tracking/airlines';

export function useForm({ dispatch, value, initValue, input, lastValue, dispatchType }) {
  const onChange = (val) => {
    const value = val || (input !== 'phoneNumber' && val === '') ? val : null;
    const payload = {
      [`${input}`]: value
    };
    dispatch({
      type: 'CLEAR_PARTIAL',
      payload
    });
  };
  const onClear = (ref) => {
    const payload = {
      [`${input}`]: ''
    };
    dispatch({
      type: 'CLEAR_PARTIAL',
      payload
    });
  };
  const onBlur = (lastValue) => {
    if ((value !== '' && value !== lastValue) || (value === '' && lastValue !== '')) {
      dispatch({
        type: dispatchType
      });
    }
  };
  return {
    value,
    defaultValue: value,
    onChange,
    onClear,
    onBlur,
    lastValue,
    isChanged: initValue !== value
  };
}

const useFilters = ({
  ui,
  getSubscription,
  availableFilters = [],
  prePopulation,
  integrationSettings,
  meta,
  getAirports,
  pageContext
}) => {
  const [fetchData, setFetchData] = useState(false);

  const track = useTrackingChangeDatalayer();

  const tracking = useCallback(
    (_, event) => {
      track(event.prevState, event.action, _);
    },
    [track]
  );

  const [state, dispatch] = useEffectReducer(
    filtersReducer,
    {
      firstName: prePopulation.firstName || '',
      lastName: prePopulation.lastName || '',
      origin: { value: prePopulation.origin || '' },
      destination: { value: '' },
      email: prePopulation.email || '',
      phoneNumber: prePopulation.phoneNumber || '',
      userInteraction: false,
      noClearDestination: true,
      navigation: 'all'
    },
    {
      tracking
    }
  );

  const locations = useOriginDestination({
    dispatch,
    origin: state.origin,
    destination: state.destination,
    showOrigin: availableFilters.includes('Origin') || availableFilters.includes('OriginMobile'),
    showDestination: true,
    filter: { getAirports, prePopulation, integrationSettings, meta, pageContext },
    initialOrigins: undefined,
    initialDestinations: [],
    originDestinationLogic: 'same',
    userInteraction: state.userInteraction
  });

  const firstName = useForm({
    dispatch,
    input: 'firstName',
    value: state.firstName,
    initValue: prePopulation.firstName,
    lastValue: state.firstName,
    dispatchType: 'INSERT_FIRST_NAME'
  });
  const lastName = useForm({
    dispatch,
    input: 'lastName',
    value: state.lastName,
    initValue: prePopulation.lastName,
    lastValue: state.lastName,
    dispatchType: 'INSERT_LAST_NAME'
  });
  const phoneNumber = useForm({
    dispatch,
    input: 'phoneNumber',
    value: state.phoneNumber,
    initValue: prePopulation.phoneNumber,
    lastValue: state.phoneNumber,
    dispatchType: 'INSERT_PHONE_NUMBER'
  });
  const email = useForm({
    dispatch,
    input: 'email',
    value: state.email,
    initValue: prePopulation.email,
    lastValue: state.email,
    dispatchType: 'INSERT_EMAIL'
  });

  const { subscriptionInfo, match, retry } = useSubscription({
    firstName: state.firstName,
    lastName: state.lastName,
    origin: state.origin,
    email: state.email,
    phoneNumber: state.phoneNumber,
    prePopulation,
    meta,
    integrationSettings,
    getSubscription,
    getAirports,
    fetchData,
    setFetchData,
    pageContext
  });
  const uiSettings = {
    ...ui,
    form: {
      ...ui?.form,
      cta: {
        ...ui?.form?.cta,
        onClick: () => {
          dispatch({
            type: 'SUBSCRIBE'
          });
          setFetchData(true);
        }
      }
    }
  };

  /**
   * This function is used after x seconds for clean all filters and remove the alert from the UI.
   */
  const clearFilters = useCallback(() => {
    const newPayload = {
      firstName: '',
      lastName: '',
      origin: { value: '' },
      email: '',
      phoneNumber: null
    };

    // TODO: Cleaning all filter
    dispatch({
      type: 'CLEAR_PARTIAL',
      payload: newPayload
    });
  }, [dispatch]);

  const cleanRequest = useCallback(() => {
    //INFO: Put the response in false to remove the alert from the UI.
    subscriptionInfo.success = false;
  }, [subscriptionInfo]);

  return {
    firstName,
    lastName,
    phoneNumber,
    email,
    //INFO: It was necessary to destructure the object to add the disabled since in mobile
    //      the map's ReduceInlineFilter was reused, bringing with it the placeholder's labelKey
    //      to be the same as the map's
    locations: {
      ...locations,
      origin: {
        ...locations?.origin,
        disabled: fetchData
      }
    },
    isFetchData: fetchData,
    navigation: state?.navigation,
    uiSettings,
    dispatch,
    subscriptionInfo,
    match,
    retry,
    clearFilters,
    cleanRequest
  };
};

export default useFilters;
